import React from 'react';
import PdfWrapper from '../../components/pdfWrapper/pdfWrapper';
import achAgreementExternalAccount from '../../../public/pdf/ach_agreement_external_account.pdf';

const ExternalAgreementPdf = () => <PdfWrapper data={achAgreementExternalAccount} />;

export default ExternalAgreementPdf;
